import { render, staticRenderFns } from "./ViewGas.vue?vue&type=template&id=2e936b63&"
import script from "./ViewGas.vue?vue&type=script&lang=js&"
export * from "./ViewGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ViewGas.vue"
export default component.exports